import React, { useState } from "react"
import Layout from "@/components/layout"
import SEO from "@/components/seo"
import { useInView } from "react-intersection-observer"
import getCountry from "@/utils/getCountry.js"
import useBigScreen from "@/hooks/bigScreen"
import style from "./index-new.module.less"
import {BaseBox, HeroSection, SmallProduct, Supports, SupportsMobile, ParallaxBox} from "@/new_components/HomePage/index"
import { 
  home_ada,
  home_air2_mobile,
  Dog_Desktop,
  Dog_mobile, 
  home_OneVideo_Mobile,
  home_OneVideo_Desktop,
  home_Air2Ultra_Desktop,
  home_Air2Ultra_Mobile,
  home_BeamPro_Desktop,
  home_BeamPro_Mobile,
  home_Air2Pro_Desktop,
  home_Air2Pro_Mobile,
  home_Hub_Desktop,
  home_Hub_Mobile,
} from "@/images/home/index"
import { 
  Native3DoF_video,
  Native3DoF_video_mobile
} from "@/images/one/index"
import { buy_link } from "@/scripts/constant.js"
import { useIntl } from "react-intl"
import { BuyStickers, HomePro, FrameAnimation } from "@/components/Home/index"
import { proBg_air2_pc_right } from "@/images/air2/index"
import Air2Svg from "@/images/SVG/air2.svg"
import EvaSvg from "@/images/SVG/home_beam_icon.svg"
import AdaSvg from "@/images/SVG/home_adapter_icon.svg"
import HomeAir from "@/images/SVG/HomeAir.svg"
import { home_beam_pc, home_beam_mobile } from "@/images/ces/index"
import { home_air_pc, home_air_mobile } from "@/images/air"
import { proBg_ada_pc } from "@/images/ada/index"
import { compareIcon, redditIcon, updateIcon } from "@/images/support"

const Index = () => {
  console.log('region', getCountry())
  const region = getCountry()
  const ifPC = useBigScreen(1000)
  const intl = useIntl()
  const moreLang = intl.formatMessage({ id: "learn_more" })
  const buyLang = intl.formatMessage({ id: "buy_now" })

  // th（泰国）的首页
  const [beamAdaRef, beamAdaInView] = useInView({ threshold: 0 })
  const [air2Ref, air2InView] = useInView({ threshold: 0 })
  const getImage = (desktopImg, mobileImg) => (ifPC ? desktopImg : mobileImg);
  const getAspectRatio = (desktopRatio, mobileRatio = 'unset') => (ifPC ? desktopRatio : mobileRatio);

  const [footerHeight, setFooterHeight] = useState(0)

  const one_intro = {
    img: "",
    video_src: getImage(home_OneVideo_Desktop, home_OneVideo_Mobile),
    devName: "XREAL One",
    tip: "homenew_one_tip1",
    desc: "one_slogan",
    btnLearn: moreLang,
    learn_link: "/one",
    learn_out: false,
    btnBuy: buyLang,
    buy_link: buy_link[region]["one"].shop,
    buy_out: true,
    aspectRatio: getAspectRatio('16 / 9', '2 / 3')
    // justifyContent: 'center'
  }

  const videos_intro1 = {
    video_src: getImage(Dog_Desktop, Dog_mobile),
    btnLearn: moreLang,
    learn_link: "/one-pro",
    learn_out: false,
    aspectRatio: !ifPC && '2 / 3'
  }

  const videos_intro2 = {
    video_src: getImage(Native3DoF_video, Native3DoF_video_mobile),
    btnLearn: moreLang,
    learn_link: "/one",
    learn_out: false,
  }

  const smProducts1 = [
    {
      devName: "XREAL Beam Pro",
      desc: "homenew_beam_pro_desc",
      img: getImage(home_BeamPro_Desktop, home_BeamPro_Mobile),
      btnLearn: moreLang,
      learn_link: "/beampro",
      learn_out: false,
      btnBuy: buyLang,
      buy_link: buy_link[region]["beampro"].shop,
      buy_out: true,
      aspectRatio: getAspectRatio('3 / 4', '2 / 3'),
      justifyContent: "flex-end"
    },
    {
      devName: "XREAL Air 2 Ultra",
      desc: "homenew_air2_ultra_desc",
      img: getImage(home_Air2Ultra_Desktop, home_Air2Ultra_Mobile),
      btnLearn: moreLang,
      learn_link: "/air2ultra",
      learn_out: false,
      btnBuy: buyLang,
      buy_link: buy_link[region]["air2ultra"].shop,
      buy_out: true,
      aspectRatio: getAspectRatio('3 / 4', '2 / 3'),
      justifyContent: "flex-end"
    }
  ]

  const smProducts2 = [
    {
      devName: "XREAL Air 2 Pro",
      desc: "homenew_air2_pro_desc",
      img: getImage(home_Air2Pro_Desktop, home_Air2Pro_Mobile),
      btnLearn: moreLang,
      learn_link: "/air2",
      learn_out: false,
      btnBuy: buyLang,
      buy_link: buy_link[region]["air2pro"].shop,
      buy_out: true,
      aspectRatio: getAspectRatio('3 / 4', '2 / 3'),
      justifyContent: "flex-start"
    },
    {
      devName: "XREAL Hub",
      desc: "homenew_hub_desc",
      img: getImage( home_Hub_Desktop, home_Hub_Mobile),
      btnLearn: moreLang,
      btnBuy: buyLang,
      buy_link: buy_link[region]["hub"].shop,
      buy_out: true,
      aspectRatio: getAspectRatio('3 / 4', '2 / 3'),
      justifyContent: "flex-start"
    }
  ]

  const supportList = [
    {
      img: compareIcon,
      // title: "homenew_support1_title",
      title: "Comparison",
      btnLearn: moreLang,
      learn_link: "/glasses/compare",
      learn_out: false
    },
    {
      img: updateIcon,
      // title: "homenew_support2_title",
      title: "Firmware Upgrade",
      btnLearn: moreLang,
      learn_link: "https://www.xreal.com/ota/",
      learn_out: true
    },
    {
      img: redditIcon,
      // title: "homenew_support3_title",
      title: "Reddit",
      btnLearn: moreLang,
      learn_link: process.env.url_reddit,
      learn_out: true
    }
  ]

  const th_air2_intro = {
    direction: "left",
    theme: "white",
    pro_name: "air2",
    background: proBg_air2_pc_right,
    background_mobile: home_air2_mobile,
    pro_logo: <Air2Svg />,
    text_id: "home.air2des",
    learn_link: "/air2",
    buy_link: "",
  }

  const th_beam_intro = {
    direction: "right",
    theme: "black",
    pro_name: "beam",
    background: home_beam_pc,
    background_mobile: home_beam_mobile,
    pro_logo: <EvaSvg />,
    text_id: "home.beamdes",
    learn_link: "/beam",
    buy_link: "",
  }
  const th_ada_intro = {
    direction: "left",
    theme: "black",
    pro_name: "adapter",
    background: proBg_ada_pc,
    background_mobile: home_ada,
    pro_logo: <AdaSvg />,
    text_id: "home.adades",
    learn_link: "/adapter",
    buy_link: "",
  }
  const th_air_intro = {
    direction: "left",
    theme: "white",
    pro_name: "air",
    background: home_air_pc,
    background_mobile: home_air_mobile,
    pro_logo: <HomeAir />,
    text_id: "home.airdes",
    learn_link: "/air",
    buy_link: "",
    sale_shop: !!buy_link[region]["air"].sale_shop_price ? true : false,
  }

  const menuBlack = region === 'th' && !air2InView && beamAdaInView;
  const headerTextBlack = region !== 'th';

  const handleFooterReadyFromHome = (height) => {
    setFooterHeight(height - 53)
  }

  return ( 
    <Layout
      footerfixed={ifPC} 
      onLayoutFooterReady={handleFooterReadyFromHome}
      menuBlack={menuBlack} 
      dontfixed={true}
      headerTextBlack={headerTextBlack}
      >
   
      <SEO page="Home" />

      {region !== "th" && (<>
        <div className={style.content}>
          
          <HeroSection />
          <ParallaxBox intro={videos_intro1} />
          {/* <Banner /> */}
          <div className={style.contentBox}>
            <BaseBox intro={one_intro}/>
          </div>
          
          
          <SmallProduct products={smProducts1} />
          {/* <SmallProduct products={smProducts1} /> */}
          <ParallaxBox intro={videos_intro2} />

          <SmallProduct products={smProducts2} />
          
          {/* {!!ifPC ? <News /> : <NewsMobile />} */}
          
          {ifPC ? <Supports supportsList={supportList}/> : <SupportsMobile supportsList={supportList}/>}
        </div>
        
          {ifPC && <div className={style.homeEmptyBox} style={{ '--footer-offset': `${footerHeight}px` }}>用于footer翻页的占位</div>}
      </>
      )}

      {region === "th" && (
        <>
          <FrameAnimation />
          <div ref={air2Ref}>
            <HomePro pro_intro={th_air2_intro} />
            <HomePro pro_intro={th_air_intro} />
          </div>
          <div ref={beamAdaRef}>
            <HomePro pro_intro={th_beam_intro} />
            <HomePro pro_intro={th_ada_intro} />
          </div>
          <BuyStickers />
        </>
      )}

    </Layout>
  )
}
export default Index